import React from "react";
import { useParams } from "react-router-dom";
import peopleData from "./data/peopleData.json";
import "./styles/ProfilePage.scss";

const ProfilePage = () => {
  const { id } = useParams();
  const person = Object.values(peopleData)
    .flat()
    .find((p) => p.id === parseInt(id));

  if (!person) {
    return <p>Person not found</p>;
  }

  return (
    <main className="profile-page">
      <section className="profile-header">
        <img src={person.headshot} alt={`${person.name}'s headshot`} />
        <section className="profile-info">
          <h2>{person.name}</h2>
          <p>
            <strong>Institution/Company:</strong> {person.institution}
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href={`mailto:${person.email}`}>{person.email}</a>
          </p>
        </section>
      </section>
      <section className="profile-details">
        <h3>Interests</h3>
        <ul>
          {person.interests.map((interest, index) => (
            <li key={index}>{interest}</li>
          ))}
        </ul>
        {/* <h3>Publications</h3>
                <ul>
                    {person.publications.map((publication, index) => (
                        <li key={index}>{publication}</li>
                    ))}
                </ul>
                <h3>Education</h3>
                <ul>
                    {person.education.map((edu, index) => (
                        <li key={index}>{edu}</li>
                    ))}
                </ul> */}
      </section>
    </main>
  );
};

// {
//   "id": 9,
//   "name": "Mikyle Fourie",
//   "role": "MA Student",
//   "areaOfResearch": "Game Design Engineering",
//   "headshot": "/ProfileImages/Mikyle.jpg",
//   "institution": "University of the Witwatersrand",
//   "email": "mikyle.fourie@gmail.com",
//   "interests": ["Mikyle is interested in AI technology and its use to streamline education, assist teachers, and create more immersive game experiences.", "Mikyle cares deeply about the ethical aspects of AI and new technology in general", "Mikyle has a passion for performance arts and narrative experience in digital and physical games"]
// },

export default ProfilePage;
